import { Stack } from '@mui/material';

import { Typography } from '@/design-system';

import { UserTabSummaryCarousel } from './components/user-tab-summary-carousel';
import { UserTabTable } from './components/user-tab-table';

export const UsersTab = () => {
  return (
    <Stack flexDirection="column" mt="16px" gap="16px">
      <Typography variant="h5">Users Summary</Typography>

      <UserTabSummaryCarousel />
      <UserTabTable />
    </Stack>
  );
};
